/* eslint-disable react/no-array-index-key, react/jsx-one-expression-per-line */
import React from 'react'
import { t, Trans } from '@lingui/macro'

import ImageTextSection from '../../../../components/common/ImageTextSection'

import faceCapture from '../../../../../assets/instructions/face_capture.png'

const heading = t`Create Yoti account`
const toggled = false
const canBeToggled = true
const paragraphs = [
  <Trans><p>Open the Yoti app.</p></Trans>,
  <Trans><p>Tap <b>Create my Yoti.</b></p></Trans>,
  <Trans><p>Follow the steps in the app to complete registration.</p></Trans>
]

const CreateYotiStep = () => (
  <ImageTextSection
    contentToggled={toggled}
    contentToggleEnabled={canBeToggled}
    imgSrc={faceCapture}
  >
    <h6 className="instructions-section__header">
      <Trans id={heading} />
    </h6>
    { paragraphs.map((p, key) => React.cloneElement(p, { key }))}
  </ImageTextSection>
)

export default CreateYotiStep
